import ApiGraphQL from './client'
import unwrapGraphQL from './unwrap'


// Every scalar `DocumentAdvanced` carries -- the keys match the full-object
// field names, so `new Document(json)` accepts the row as-is.
//
// `history` is deliberately NOT selected: it is a per-row nested list, and a
// picker shows a name, a project and a date. Add the sub-selection here if a
// caller ever needs it -- `DocumentHistory` already tolerates its absence.
const DOCUMENT_FIELDS = `
    id name projectId noteTypeId createdByUserId systemType
    accessRead accessWrite momentCreated momentUpdated isDeleted
    properties editors historyCount
`

const DOCUMENTS_UDS = `query ($input: DocumentsUdsQueryInput!) {
    documentsUds(input: $input) { ${DOCUMENT_FIELDS} }
}`


export type DocumentsUdsInput = {
    projectIds?         : ID[]
    documentTypeIds?    : ID[]
}

// One row as it comes back. Dates are raw strings -- the caller parses.
export type DocumentAdvancedJson = {
    id              : ID
    name            : string
    projectId       : ID
    noteTypeId      : ID
    systemType      : number
    isDeleted       : boolean
    momentCreated   : string | null
    momentUpdated   : string | null

    [key: string]   : any
}


export default class ApiDocumentGql {

    // Both filters are optional; omitting them lists every document the viewer
    // can see. There is no name filter on the input -- callers that search do it
    // client-side.
    static documentsUds(input: DocumentsUdsInput = {}) {
        return unwrapGraphQL<DocumentAdvancedJson[]>(
            ApiGraphQL.execute(DOCUMENTS_UDS, {input}),
            'documentsUds'
        )
    }
}
